import { instance, isMock, endpoint, generator } from 'api'
import { mocker } from 'api/hrmsLov/mocker'
import moment from 'moment'

export default {
  getLovLabels () {
    if (isMock) return generator(mocker.lovLabels())
    return instance().get(endpoint + '/hrmsLov/getLabels')
  },
  getLovCodempid () {
    if (isMock) return generator(mocker.lovCodempid())
    return instance().get(endpoint + '/hrmsLov/getCodempid')
  },
  getLovCodempid9 () {
    if (isMock) return generator(mocker.lovCodempid())
    return instance().get(endpoint + '/hrmsLov/getCodempid9')
  },
  getLovCodpos () {
    if (isMock) return generator(mocker.lovCodpos())
    return instance().get(endpoint + '/hrmsLov/getCodpos')
  },
  getLovCodapp () {
    if (isMock) return generator(mocker.lovCodapp())
    return instance().get(endpoint + '/hrmsLov/getCodapp')
  },
  getLovNummemo () {
    if (isMock) return generator(mocker.lovNummemo())
    return instance().get(endpoint + '/hrmsLov/getNummemo')
  },
  getLovCodcours () {
    if (isMock) return generator(mocker.lovCodcours())
    return instance().get(endpoint + '/hrmsLov/getCodcours')
  },
  getLovNumappl () {
    if (isMock) return generator(mocker.lovNumappl())
    return instance().get(endpoint + '/hrmsLov/getNumappl')
  },
  getLovCodform () {
    if (isMock) return generator(mocker.lovCodform())
    return instance().get(endpoint + '/hrmsLov/getCodform')
  },
  getLovNumreq () {
    if (isMock) return generator(mocker.lovNumreq())
    return instance().get(endpoint + '/hrmsLov/getNumreq')
  },
  getLovCodaplvl () {
    if (isMock) return generator(mocker.lovCodaplvl())
    return instance().get(endpoint + '/hrmsLov/getCodaplvl')
  },
  getLovGrdscor (params) {
    if (isMock) return generator(mocker.lovGrdscor())
    let param = params.p_codempid + '/' + params.p_dteyreap + '/' + params.p_numtime + '/' + params.p_kpino
    return instance().get(endpoint + '/hrmsLov/getGrdscor/' + param)
  },
  getLovCodappr () {
    if (isMock) return generator(mocker.lovCodappr())
    return instance().get(endpoint + '/hrmsLov/getLovCodappr')
  },
  getLovCodshift () {
    if (isMock) return generator(mocker.lovCodshift())
    return instance().get(endpoint + '/hrmsLov/getCodshift')
  },
  getLovCodroom () {
    if (isMock) return generator(mocker.lovCodroom())
    return instance().get(endpoint + '/hrmsLov/getCodroom')
  },
  getLovCodasset () {
    if (isMock) return generator(mocker.lovCodasset())
    return instance().get(endpoint + '/hrmsLov/getCodasset')
  },
  getLovCodcalen () {
    if (isMock) return generator(mocker.lovCodcalen())
    return instance().get(endpoint + '/hrmsLov/getCodcalen')
  },
  getLovCodcompy () {
    if (isMock) return generator(mocker.lovCodcompy())
    return instance().get(endpoint + '/hrmsLov/getCodcompy')
  },
  getLovBatchno () {
    if (isMock) return generator(mocker.lovBatchno())
    return instance().get(endpoint + '/hrmsLov/getBatchno')
  },
  getLovCostcent () {
    if (isMock) return generator(mocker.lovCostcent())
    return instance().get(endpoint + '/hrmsLov/getCostcent')
  },
  getLovCodbrlc () {
    if (isMock) return generator(mocker.lovCodbrlc())
    return instance().get(endpoint + '/hrmsLov/getCodbrlc')
  },
  getLovCodtency () {
    if (isMock) return generator(mocker.lovCodtency())
    return instance().get(endpoint + '/hrmsLov/getCodtency')
  },
  getLovCodedlv () {
    if (isMock) return generator(mocker.lovCodedlv())
    return instance().get(endpoint + '/hrmsLov/getCodedlv')
  },
  getLovCodjob () {
    if (isMock) return generator(mocker.lovCodjob())
    return instance().get(endpoint + '/hrmsLov/getCodjob')
  },
  getLovCodempmt () {
    if (isMock) return generator(mocker.lovCodempmt())
    return instance().get(endpoint + '/hrmsLov/getCodempmt')
  },
  getLovTypemp () {
    if (isMock) return generator(mocker.lovTypemp())
    return instance().get(endpoint + '/hrmsLov/getTypemp')
  },
  getLovTyppayroll () {
    if (isMock) return generator(mocker.lovTyppayroll())
    return instance().get(endpoint + '/hrmsLov/getTyppayroll')
  },
  getLovCodinst () {
    if (isMock) return generator(mocker.lovCodinst())
    return instance().get(endpoint + '/hrmsLov/getCodinst')
  },
  getLovStaemp () {
    if (isMock) return generator(mocker.lovStaemp())
    return instance().get(endpoint + '/hrmsLov/getStaemp')
  },
  getLovCoddomcl () {
    if (isMock) return generator(mocker.lovCoddomcl())
    return instance().get(endpoint + '/hrmsLov/getCoddomcl')
  },
  getLovCodprovr () {
    if (isMock) return generator(mocker.lovCoddomcl())
    return instance().get(endpoint + '/hrmsLov/getCodprovr')
  },
  getLovTypleave () {
    if (isMock) return generator(mocker.lovTypleave())
    return instance().get(endpoint + '/hrmsLov/getTypleave')
  },
  getLovCoursTrain (params) {
    if (isMock) return generator(mocker.lovCoursTrain())
    let param = params || moment().format('YYYY')
    return instance().get(endpoint + '/hrmsLov/getCoursTrain/' + param)
  },
  getLovCodempstapp () {
    if (isMock) return generator(mocker.lovCodempstapp())
    return instance().get(endpoint + '/hrmsLov/getCodempstapp')
  }
}



// WEBPACK FOOTER //
// ./src/api/hrmsLov/index.js